// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"styles-module--layoutWrapper--p86yT","header":"styles-module--header--fwLN7","logo":"styles-module--logo--283dm"};